import styled from "styled-components";
import { viewSizeCalculator } from "../../../../../utils";

const HexBinGraphTooltip = ({ data }) => {
  return (
    <MainWrapper className="tooltip_body">
      <TooltipMainWrapper>
        <LabelWrapper>
          {`${data.market?.toLowerCase()} (${data?.abbrev})` || ""}
        </LabelWrapper>
        {/* <ValueMainWrapper color={data?.color}> */}
        <ValueWrapper style={{ paddingTop: "2px" }}>
          Hospitals: {data?.value || 0}
        </ValueWrapper>
        <ValueWrapper>
          Case Density: {data?.case_density} <div style={{fontSize: `${viewSizeCalculator(0.7)}`}}>/100K pop</div>
        </ValueWrapper>
        {/* </ValueMainWrapper> */}
      </TooltipMainWrapper>
      <Triangle position={data?.position || "bottom"} />
    </MainWrapper>
  );
};

export default HexBinGraphTooltip;

const MainWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const TooltipMainWrapper = styled.div`
  display: flex;
  flex-direction: column; // added
  padding: ${() =>
    `${viewSizeCalculator(0.5625)} ${viewSizeCalculator(0.9375)}`};
  /* justify-content: center; */
  /* align-items: center; */
  gap: ${() => `${viewSizeCalculator(0.3)}`};
  border-radius: ${() => `${viewSizeCalculator(0.3125)}`};
  background: #333; // #fff
  /* box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.5); */
  /* white-space: nowrap; */
`;

const LabelWrapper = styled.div`
  color: #fff; // #242639
  font-family: "Inter";
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;
  white-space: nowrap;
  text-transform: capitalize;
`;

const ValueMainWrapper = styled.div`
  width: fit-content;
  display: flex;
  padding: ${() =>
    `${viewSizeCalculator(0.45)} ${viewSizeCalculator(0.75)}`}; //0.5rem 0.625rem;
  justify-content: center;
  align-items: center;
  gap: ${viewSizeCalculator(0.625)}; //0.625rem;
  border-radius: ${() => `${viewSizeCalculator(0.3125)}`};
  background: ${({ color }) => color};
`;

const ValueWrapper = styled.div`
  color: #fff;
  /* text-align: center; */
  font-family: "Inter";
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 400; // 700
  /* text-transform: uppercase; */
  white-space: nowrap;
  white-space: nowrap;

  display: flex;
  align-items: baseline;

`;

const Triangle = styled.div`
  position: absolute;
  width: 0;
  height: 0;

  ${({ position }) => {
    switch (position) {
      case "bottom":
        return `
          bottom: ${`-${viewSizeCalculator(0.5)}`}; // Dynamically calculated
          left: 50%;
          transform: translateX(-50%);
          border-left: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-right: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-top: ${`${viewSizeCalculator(0.563)} solid #333`}; // Adjust color as needed
        `;
      case "left":
        return `
          left: ${`-${viewSizeCalculator(0.5)}`};
          top: 50%;
          transform: translateY(-50%);
          border-top: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-bottom: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-right: ${`${viewSizeCalculator(0.563)} solid #333`};
        `;
      case "right":
        return `
          right: ${`-${viewSizeCalculator(0.5)}`};
          top: 50%;
          transform: translateY(-50%);
          border-top: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-bottom: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-left: ${`${viewSizeCalculator(0.563)} solid #333`};
        `;
      default:
        return `
          bottom: ${`-${viewSizeCalculator(0.5)}`};
          left: 50%;
          transform: translateX(-50%);
          border-left: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-right: ${`${viewSizeCalculator(0.375)} solid transparent`};
          border-top: ${`${viewSizeCalculator(0.563)} solid #333`};
        `;
    }
  }}
`;
